/* global axios */
import { ExceptionWithMessage } from '../../../../shared/helpers/CustomErrors';
import { stagingUrl } from '../../../api/automation.stub';
import JwtAuth from '../../../api/jwtAuth';
import types from '../../mutation-types';
import { transformLegacyToPhoenixPayload } from '../../../helper/phoenixTemplateSendAdapter';
import getUuid from 'widget/helpers/uuid';

const legacyUrl =
  process.env.FRONTEND_ENV === 'develop'
    ? stagingUrl + '/automation/message'
    : window.location.protocol +
    '//' +
    window.location.hostname +
    '/automation/message';

const phoenixUrl =
  process.env.FRONTEND_ENV === 'develop'
    ? stagingUrl + '/inboxmw/whatsapp/templates/send/list/simplified'
    : window.location.protocol +
    '//' +
    window.location.hostname +
    '/inboxmw/whatsapp/templates/send/list/simplified';

export const actions = {
  sendMessage: async ({ commit, rootGetters }, { data }) => {
    try {
      commit(types.SET_MESSAGES_UI_FLAG, { isSending: true });
      const jwtAuthTokens = await JwtAuth.getUserTokens();
      const isPhoenix = rootGetters['accounts/isPhoenix'];

      let response;

      if (isPhoenix) {
        // Phoenix account - use new endpoint and payload format
        let contactData = null;

        // For single sends, fetch contact data if contactId is present
        if (data.contactId) {
          const contact = rootGetters['contacts/getContact'](data.contactId);
          if (contact && contact.id) {
            contactData = {
              name: contact.name,
              email: contact.email,
              phone_number: contact.phone_number,
              custom_attributes: contact.custom_attributes || {},
              additional_attributes: contact.additional_attributes || {},
            };
          }
        }

        // Transform payload to Phoenix format
        const phoenixPayload = transformLegacyToPhoenixPayload(
          { data },
          { contact: contactData }
        );

        // Send to Phoenix endpoint with Idempotency-Key header
        response = await axios.post(phoenixUrl, phoenixPayload, {
          headers: {
            Authorization: `Bearer ${jwtAuthTokens.access_token}`,
            'Idempotency-Key': getUuid(),
          },
        });

        // Phoenix endpoint returns different response structure
        // For list sends: { jobId, status, message, estimatedCompletionTime, statusUrl, summary }
        // For now, we'll treat any successful response (201) as success
        if (response.status === 201) {
          return {
            status: 200, // Return success
            jobId: response.data?.jobId,
            phoenixResponse: response.data,
          };
        }
      } else {
        // Legacy account - use existing endpoint and payload
        response = await axios.post(legacyUrl, data, {
          headers: {
            Authorization: `Bearer ${jwtAuthTokens.access_token}`,
          },
        });

        if (!response?.data) {
          throw new Error();
        }

        if (response.status !== 206) {
          return null;
        }

        return {
          status: response.status,
          failed: response.data.failed,
        };
      }
    } catch (error) {
      if (
        error?.response?.status === 400 &&
        error?.response?.data?.message === 'Attribute is empty'
      ) {
        throw new ExceptionWithMessage(error?.response?.data);
      }

      throw error;
    } finally {
      commit(types.SET_MESSAGES_UI_FLAG, { isSending: false });
    }
  },
};
